import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Truck, CheckCircle2, XCircle } from "lucide-react";

export default function PincodeCheck({ weightKg = 0.5 }) {
  const [pin, setPin] = useState("");
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);

  const check = async () => {
    if (!/^\d{6}$/.test(pin)) { setResult({ error: "Enter a valid 6-digit PIN code" }); return; }
    setChecking(true);
    setResult(null);
    try {
      const r = await api.get(`/pincode-check?pincode=${pin}&weight_kg=${weightKg}`);
      setResult(r.data);
    } catch { setResult({ error: "Could not check right now" }); }
    finally { setChecking(false); }
  };

  return (
    <div className="border border-[#E7E5E4] rounded-md p-3 bg-[#FAF3E7]" data-testid="pincode-check">
      <div className="flex items-center gap-2 mb-2">
        <Truck className="h-4 w-4 text-[#7C1F30]" />
        <span className="text-sm font-medium">Delivery availability</span>
      </div>
      <div className="flex gap-2">
        <Input
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="Enter 6-digit PIN"
          className="h-9 bg-white"
          data-testid="pincode-input"
          maxLength={6}
        />
        <Button onClick={check} disabled={checking} size="sm" data-testid="pincode-check-btn" className="bg-[#7C1F30] hover:bg-[#8D2A3D] rounded-full">
          {checking ? "Checking..." : "Check"}
        </Button>
      </div>
      {result && (
        <div className="mt-3 text-xs">
          {result.error && <div className="text-red-600 flex items-center gap-1" data-testid="pincode-err"><XCircle className="h-3.5 w-3.5" />{result.error}</div>}
          {result.serviceable && (
            <div className="text-green-800 flex items-start gap-1" data-testid="pincode-ok">
              <CheckCircle2 className="h-3.5 w-3.5 mt-0.5 shrink-0" />
              <div>
                Delivers to <strong>{pin}</strong> in <strong>{result.eta_days ? `${result.eta_days} days` : (result.etd || "3–5 days")}</strong>
                {result.courier && <div className="text-[#78716C]">via {result.courier}</div>}
              </div>
            </div>
          )}
          {result.serviceable === false && !result.error && (
            <div className="text-red-600 flex items-center gap-1" data-testid="pincode-fail"><XCircle className="h-3.5 w-3.5" />Sorry, not serviceable to {pin}</div>
          )}
        </div>
      )}
    </div>
  );
}
